export default __webpack_public_path__ + "static/media/instructor.faef686d.jpeg";